import { FC, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentUser, selectPermissions } from '@app/redux/features/userSlice';

interface IProps {
  permissions: string | string[];
  children: ReactNode | ReactNode[];
}

const PermissionGuard: FC<IProps> = ({ permissions, children }) => {
  const availablePermissions = useSelector(selectPermissions);
  const user = useSelector(selectCurrentUser);
  const requestedPermissions = Array.isArray(permissions) ? permissions : [permissions];

  let isGranted = true;

  if (!user?.user?.is_admin) {
    requestedPermissions.map(requestedPermission => {
      if (!availablePermissions.includes(requestedPermission)) {
        isGranted = false;
      }
    });
  }

  return <>{isGranted ? <>{children}</> : null}</>;
};

export default PermissionGuard;
